(function () {
  /**
   * @deprecated Please use src2/core/models/contact/Contact.js
   *
   * @ngdoc factory
   * @name binky.core.contact:Contact
   * @description Model for an individual Contact
   */
  angular.module('binky.core.contact').factory('Contact', getContactModel);

  /* @ngInject */
  function getContactModel(_, binkySrc2, feature) {
    const EDITABLE_FIELDS = ['email', 'name', 'phone'];
    /**
     * @deprecated This class has been ported to src2.
     * Any subsequent changes should be made to the src2 implementation.
     */
    class Contact {
      /**
       * @class
       * @description Creates a new Contact for use.
       *
       * @param {Object} [options] Initialization Object (params described below)
       * @param {String} [options.email] A Contact's email
       * @param {String} [options.name] A Contact's name
       * @param {String} [options.phone] A Contact's phone number
       */
      constructor(options) {
        initModel(this, options);
      }

      /**
       * @returns {boolean} true if all the fields are filled
       */
      isComplete() {
        return !!(this.email && this.name && this.phone);
      }

      /**
       * @returns {boolean} true if all the fields are not filled
       */
      isEmpty() {
        return !!(!this.email && !this.name && !this.phone);
      }

      /**
       * @returns {boolean} true if at least one of the fields are filled
       */
      isPartiallyComplete() {
        return !!(this.email || this.name || this.phone) && !this.isComplete();
      }
    }

    /** Return reference to Constructor function **/
    return feature.isEnabled('temp_react_port_contact')
      ? binkySrc2.models.contact.Contact
      : Contact;

    /** Private Methods **/
    /**
     * @description Initializes Contact data from options.
     *
     * @param {Object} model Contact model Object instance to initialize. See constructor.
     * @param {Object} options Data to initiate the model with.
     *
     * @returns {Object} the model with selected values
     */
    function initModel(model, options) {
      const clonedOptions = _.cloneDeep(options);
      return _.assignIn(model, _.pick(clonedOptions, EDITABLE_FIELDS));
    }
  }
})();
